import BaseLayout from 'components/Layout';
import withGuard from 'components/withGuard';
import { PERMISSIONS } from 'constants/permissions';
import Ingredients from 'containers/GlobalMenuManagement/Ingredients';
import React from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import HandoffSheets from './HandoffSheets';
import PrepSheet from './PrepSheet';
import PullSheet from './PullSheet';

function PrepKitchen() {
  const location = useLocation();
  const isFullBleedSheet = location.pathname.includes('/prep-sheet')
    || location.pathname.includes('/pull-sheet')
    || location.pathname.includes('/handoff-sheets');

  return (
    <BaseLayout header={isFullBleedSheet ? null : (
      <BaseLayout.Header title="Prep & Kitchen" />
    )}
    >
      <Routes>
        <Route path="ingredients" element={<Ingredients />} />
        <Route path="pull-sheet" element={<PullSheet />} />
        <Route path="prep-sheet" element={<PrepSheet />} />
        <Route path="handoff-sheets" element={<HandoffSheets />} />
        <Route path="*" element={<Navigate to="ingredients" replace />} />
      </Routes>
    </BaseLayout>
  );
}

export default withGuard(PrepKitchen, [PERMISSIONS.GLOBAL_MENU], { redirect: true });
